/**
 * Sessions API Module
 * Методы для управления сессиями пользователей
 * 
 * @typedef {import('./types').SessionDto} SessionDto
 * @typedef {import('./types').TerminateSessionResponse} TerminateSessionResponse
 * @typedef {import('./types').TerminateAllSessionsResponse} TerminateAllSessionsResponse
 * @typedef {import('./types').RevokeAllSessionsRequest} RevokeAllSessionsRequest
 * @typedef {import('./types').RevokeAllSessionsResponse} RevokeAllSessionsResponse
 */

import { authFetch } from '../authClient';

/**
 * GET /api/auth/sessions
 * Получить список активных сессий текущего пользователя
 * @returns {Promise<SessionDto[]>}
 */
export async function getSessions() {
  return authFetch('/api/auth/sessions');
}

/**
 * DELETE /api/auth/sessions/{id}
 * Завершить конкретную сессию
 * @param {number} sessionId
 * @returns {Promise<TerminateSessionResponse>}
 */
export async function terminateSession(sessionId) {
  return authFetch(`/api/auth/sessions/${sessionId}`, {
    method: 'DELETE',
  });
}

/**
 * DELETE /api/auth/sessions/all
 * Завершить все сессии кроме текущей
 * @returns {Promise<TerminateAllSessionsResponse>}
 */
export async function terminateAllSessions() {
  return authFetch('/api/auth/sessions/all', {
    method: 'DELETE',
  });
}

/**
 * POST /api/auth/sessions/revoke-all
 * Отозвать все сессии пользователя (admin only)
 * @param {RevokeAllSessionsRequest} data
 * @returns {Promise<RevokeAllSessionsResponse>}
 */
export async function revokeAllSessions(data) {
  return authFetch('/api/auth/sessions/revoke-all', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
